import React, { useState } from "react";
import { withAppHOC } from "../../../hoc";
import PageHeading from "../../../components/PageHeader/PageHeader";
import OverlayLoader from "../../../components/OverlayLoader/OverlayLoader";
import { Grid, GridItem } from "../../../components/Grid";
import {
    FormContainer,
    Form,
    Fieldset,
    Label,
    FileInput,
    MessageBox,
    CreateButton,
    ResetButton,
} from "../../../components/FormElements";
import API from "../../../api";
import { API_RESPONSE_TYPES } from "../../../constants";

const ExcelRecharge = (props) => {
    const [isLoading, setIsLoading] = useState(false);
    const [responseStatus, setResponseStatus] = useState("");
    const [responseMessage, setResponseMessage] = useState("");
    const [excelFile, setExcelFile] = useState([]);

    const resetResponseData = () => {
        setResponseStatus("");
        setResponseMessage("");
    };

    const resetForm = () => {
        setExcelFile([]);
    };

    const onSubmit = (e) => {
        e.preventDefault();

        if (!excelFile || excelFile.length === 0) {
            setResponseStatus(API_RESPONSE_TYPES.FAILURE);
            setResponseMessage("Please select an Excel file");
            return;
        }

        setIsLoading(true);
        resetResponseData();

        const formData = new FormData();
        formData.append("file", excelFile[0]);

        API.post("/upload-excel-recharge", formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        })
            .then((response) => {
                const { status, message } = response.data;
                setResponseStatus(status);
                setResponseMessage(message);

                if (status === API_RESPONSE_TYPES.SUCCESS) {
                    resetForm();
                }
            })
            .catch((error) => {
                setResponseStatus(API_RESPONSE_TYPES.FAILURE);
                setResponseMessage(error.message);
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    return (
        <>
            <PageHeading {...props} />
            {isLoading && <OverlayLoader />}

            <FormContainer>
                <Form method="POST" action="#" onSubmit={onSubmit}>
                    <Grid columns={"calc(50% - 10px) calc(50% - 10px)"}>
                        <GridItem>
                            <Fieldset>
                                <Label required>Upload Excel File</Label>
                                <FileInput
                                    files={excelFile}
                                    onChange={setExcelFile}
                                    accept=".xlsx,.xls"
                                    disabled={isLoading}
                                />
                            </Fieldset>
                        </GridItem>
                    </Grid>

                    {responseMessage && (
                        <MessageBox type={responseStatus}>
                            {responseMessage}
                        </MessageBox>
                    )}

                    <Grid columns={"1fr 1fr"}>
                        <CreateButton disabled={isLoading} type="submit">
                            Upload
                        </CreateButton>
                        <ResetButton
                            disabled={isLoading}
                            type="button"
                            onClick={resetForm}
                        >
                            Reset
                        </ResetButton>
                    </Grid>
                </Form>
            </FormContainer>
        </>
    );
};

export default withAppHOC(ExcelRecharge);